import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/service/login.service';
import { jointAccountEasyConfigV2 } from 'src/environments/environment';


@Component({
    selector: 'app-joint-account-easy',
    template: ''
})
export class JointAccountEasyComponent implements OnInit {

  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(async (params) => {
      const inApp = params['inApp'];
      if (inApp) {
        jointAccountEasyConfigV2.redirectUri = jointAccountEasyConfigV2.redirectUri + '&inApp=true';
      }

    });
  }

  ngOnInit(): void {
    this.loginService.login(jointAccountEasyConfigV2);
  }
}
